import axios from "axios";
import { env } from "../.env";

class ApiHandlersModel {
    
    async createApiCall({method = "get", url, reqObj = null, params = null, validation = false}) {

        const toket = localStorage.getItem("toket")

        console.log(env);

        return await axios({
            method,
            url : `${env.REACT_APP_ROOT_URL}${url}`,
            headers : {
                "accept": "application/json",
                "Content-Type": "application/json",
                "toket" : validation ? toket : null
            },
            data : reqObj,
            params
        })    
    }

    async response(request) {

        try {
            const response = await this.createApiCall(request);

                if(response.status === 200 ||response.status === 201 ||response.status === 202) {
                    if(response.data){
                        return {type : true, data : response.data}
                    } else {
                        return {type : false, message : "خطا در بر قراری ارتباط با سرور", status : response.status }
                    }
                }

        } catch (error) {

            return this.fail(error);

        }

    }

    fail(e) {

        let message = "";

        if(!e?.response?.data?.data) {
            message = "خطا در بر قراری ارتباط با سرور";
        } else {
            message = e?.response?.data?.data
        }

        return {
            type:false,
            message : message,
            status : ( e.response && e.response.status ) ? e.response.status : null
        }
    }
}

const requestModel = new ApiHandlersModel();

export default requestModel;